module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-1600.8638500b.svg";